<div class="container" *ngIf="finishedLoading">
    <div class="row">
        <div class="col-lg-12"  *ngFor="let item of ReturnintoBoxes">
            <div class="row marginBottom2Rem">
                <mat-card appearance="outlined" class="example-card">
                    <mat-card-content>
                        <div class="row" style="display: flex; align-items: flex-start;">
                            <div class="col-sm-3">
                                <div class="imageContainer">
                                    <img class="cardImage" mat-card-image [hidden]="!loadedIMG" (load)="loadedIMG = true" src="{{item.IMAGE_FILE}}">
                                    <div *ngIf="!loadedIMG" class="center-object-vertical-horizontal">
                                        <mat-spinner [diameter]="40"></mat-spinner>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-9">
                                <div [innerHtml]="item.TEXT_FILE | sanitizeHtml" class="text-content"></div>
                                <h6 class="subHeading">Kategorien</h6>
                                <mat-chip-set>
                                    <mat-chip class="primaryChip" selected>
                                        {{item[2] | translateState}}
                                    </mat-chip>
                                    <mat-chip class="primaryChip" selected>
                                        {{item[3] | translateState}}
                                    </mat-chip>
                                </mat-chip-set>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions align="end">
                        <button mat-button color="secondary" (click)="deleteBox(item)">Löschen</button>
                        <button mat-button color="primary" [routerLink]="['edit',item[0]]">Bearbeiten</button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>


        <div class="col-lg-12"  *ngIf="ReturnintoBoxes.length == 0 && finishedLoading">
            <div class="row marginBottom2Rem">
                <mat-card appearance="outlined" class="example-card">
                    <mat-card-header>
                        <mat-card-title>
                            Noch keine Werbeboxen angelegt!
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row" style="display: flex; align-items: flex-start;">
                            <div class="col-sm-12">
                                Um Ihren Kunden Werbeboxen in der Vorteilswelt anzuzeigen, müssen Sie diese anlegen.
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions align="end">
                        <button mat-button color="primary" [routerLink]="['add']">Anlegen</button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
    </div>
</div>
<button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
    <mat-icon>add</mat-icon>
</button>

<div class="container" *ngIf="!finishedLoading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>